import { userStorage_client, userStorage } from '@/configs/storages';

export async function clearAll() {
  localStorage.clear();
  await clearDB(false);
}

export async function clearDB(retainUser = true) {
  userStorage.setItem('clear_DB_flag', true);
  if (retainUser) {
    const user = await userStorage_client.getItem('user');
    userStorage.setItem('clear_DB_user', user);
  }
  location.reload();
}

export async function clearOPFS() {
  const root = await navigator.storage.getDirectory();
  async function deleteAll(dir: any) {
    for await (const entry of dir.values()) {
      if (entry.kind === 'file') {
        await dir.removeEntry(entry.name);
      } else if (entry.kind === 'directory') {
        await deleteAll(entry);
        await dir.removeEntry(entry.name);
      }
    }
  }
  await deleteAll(root);
}

(async () => {
  const isOldData = userStorage.getItem('user'); // TODO amo: Old Version data.
  if (isOldData) {
    await clearAll();
  }

  const flag = userStorage.getItem('clear_DB_flag');
  if (flag) {
    await clearOPFS();
    userStorage.removeItem('clear_DB_flag');
  }
})();
